<template>
  <div>
    <v-row>
      <!-- Exercise column -->
      <v-col cols="12" v-if="content">
        <exercise-logic-multiple
          exCollection="attributesPt2ExCollection"
          refCollection="attributesPt1ExCollection"
          @ready="onReady"
          @error="onError"
          @saved="onSaved"
          @savedNext="onSavedNext"
          @loadedEx="onLoadedEx"
          @loadedRef="onLoadedRef"
          :saveState="saveState"
          :doc="doc"
          :shared="false"
          :projectShared="false"
          :pid="true"
          :synced="false"
        >
          <template slot-scope="{ saveExercise }">
            <v-stepper v-model="e1">
              <v-stepper-header>
                <v-stepper-step
                  color="amber"
                  :complete="e1 > 1"
                  step="1"
                  @click="el = 1"
                  >Part 1</v-stepper-step
                >
                <v-divider></v-divider>
                <v-stepper-step
                  color="amber"
                  :complete="e1 > 2"
                  step="2"
                  @click="el = 2"
                  >Part 2</v-stepper-step
                >
                <v-divider></v-divider>
              </v-stepper-header>

              <v-stepper-items>
                <!-- Step 1 -->
                <v-stepper-content step="1">
                  <v-row>
                    <v-col cols="4" class="mb-4">
                      <h2
                        class="headline"
                        v-text="content.exercise_benefits.step1.title"
                      ></h2>
                    </v-col>

                    <v-col cols="8" class="">
                      <p
                        v-for="(item, index) in content.exercise_benefits.step1
                          .description"
                        :key="index"
                        v-text="item"
                      />
                    </v-col>
                  </v-row>

                  <v-expansion-panels light>
                    <v-expansion-panel>
                      <v-expansion-panel-header
                        ><span class="subtitle-1"
                          >Attributes <span class="small">(Expand)</span></span
                        ></v-expansion-panel-header
                      >
                      <v-expansion-panel-content>
                        <v-row>
                          <v-col
                            cols="4"
                            v-for="(item, index) in results.attributes"
                            :key="index"
                          >
                            <v-chip :class="item.color" class="mt-0 mb-4">
                              {{ item.title }}
                            </v-chip>
                            <p class="" v-html="item.description"></p>
                            <ul class="no-bullets">
                              <li
                                v-for="(sub, count) in item.items"
                                :key="`${index}-${count}`"
                              >
                                {{ sub }}
                              </li>
                            </ul>
                          </v-col>
                        </v-row>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>

                  <v-row v-if="doc">
                    <v-col cols="12" offset="0">
                      <v-row>
                        <v-col cols="12">
                          <v-card
                            height="100%"
                            :color="content.exercise_benefits.color"
                          >
                            <v-card-title>Benefits</v-card-title>
                            <v-card-text>
                              <benefits-area
                                v-model="doc.benefits"
                                name="benefits"
                                title="Benefits"
                                subtitle=""
                                :attributes="results.attributes"
                                :dropdown="audiences"
                                :content="content"
                                @add="add"
                                @edit="edit"
                                @remove="remove"
                                @handleEnd="handleEnd"
                              ></benefits-area>
                            </v-card-text>
                          </v-card>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>

                  <bottom-navigation
                    :save="true"
                    :next="true"
                    :prev="false"
                    :gridView="false"
                    :gridToggle="false"
                    @save="saveExercise(true)"
                    @prev="prevStep"
                    @next="nextStep()"
                  >
                  </bottom-navigation>
                </v-stepper-content>
                <!-- Step 2 -->
                <v-stepper-content step="2">
                  <v-row>
                    <v-col cols="4" class="mb-4">
                      <!-- <h2
                        class="headline"
                        v-text="$t(`${$route.meta.content}.step2.title`)"
                      ></h2> -->
                    </v-col>

                    <v-col cols="8" class="">
                      <p
                        v-for="(item, index) in content.exercise_benefits.step2
                          .description"
                        :key="index"
                        v-text="item"
                      />
                    </v-col>
                  </v-row>

                  <v-row v-if="doc">
                    <v-col cols="12" offset="0">
                      <benefits-results
                        :items="doc.benefits"
                        :attributes="results.attributes"
                        :content="content"
                        :phrase="content.exercise_benefits.step2.phrase"
                        :dropdown="audiences"
                        @handleEnd="handleEnd"
                      />
                    </v-col>
                  </v-row>

                  <bottom-navigation
                    :save="true"
                    :next="false"
                    :prev="true"
                    :gridView="false"
                    :gridToggle="false"
                    @save="saveExercise(true)"
                    @prev="prevStep"
                    @next="saveExercise(false)"
                  >
                  </bottom-navigation>
                </v-stepper-content>
              </v-stepper-items>
            </v-stepper>
          </template>
        </exercise-logic-multiple>
      </v-col>
    </v-row>

    <v-dialog v-if="content" v-model="dialog" max-width="800">
      <v-card>
        <v-card-title class="headline">{{
          content.exercise_benefits.saved.title
        }}</v-card-title>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn class="amber black--text" text @click="dialog = false">
            Close
          </v-btn>

          <v-btn color="amber accent-1 black--text" text to="/users/dashboard">
            Back to Dashboard
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapState } from "vuex";
import { BottomNavigation } from "@/components/core";
// import { ExerciseLogic } from "@/components/exercises";
import { ExerciseLogicMultiple } from "@/components/exercises";
import BenefitsMixin from "@/views/user/exercises/attributes/BenefitsMixin";

import {
  BenefitsArea,
  BenefitsResults,
} from "@/views/user/exercises/attributes";

const fb = require("@/firebaseConfig.js");

export default {
  name: "UserArchitecture",

  async created() {
    // GET request using fetch with async/await
    const response = await fetch(`/content/${this.$route.params.id}.json`);
    const data = await response.json();
    this.content = data;
    this.getAudiences();
  },

  data() {
    return {
      content: null,
      e1: 1,
      exercises: null,
      refs: null,
      allItems: null,
      listName: "",
      results: {
        attributes: [],
      },
      doc: {
        benefits: [],
      },
      listLength: 1,
      debug: false,
      dialog: false,
      saveState: false,
      autoSave: true,
      colorTable: [],
      audiencesFromExercise: null,
    };
  },

  mixins: [BenefitsMixin],

  components: {
    BottomNavigation,
    ExerciseLogicMultiple,
    BenefitsArea,
    BenefitsResults,
  },
  watch: {
    e1(val) {
      if (val === 3) {
        this.createList();
      }
    },
  },
  computed: {
    ...mapState([
      "userProfile",
      "currentUser",
      "currentProject",
      "currentProjectModel",
      "colors",
    ]),
    audiences() {
      if (this.content) {
        return this.content.exercise_benefits.getAudiencesFromExercise
          ? this.audiencesFromExercise
          : this.content.exercise_benefits.step1.dropdown;
      } else {
        return [];
      }
    },
  },

  methods: {
    getAudiences() {
      let ref = fb.audienceExCollection.where(
        "pid",
        "==",
        this.$route.params.id
      );
      ref
        .get()
        .then((result) => {
          let items = [];
          result.docs.forEach((doc) => {
            let post = doc.data();
            items.push(post);
          });
          if (items && items.length) {
            const body = items[0].doc.matrix;
            this.audiencesFromExercise = [...body.q1, ...body.q2, ...body.q3];
          }
        })
        .catch(function() {});
    },
    nextStep() {
      this.e1++;
    },
    prevStep() {
      this.e1--;
    },
    onReady() {},
    onError() {
      console.log("error");
    },
    onSaved() {
      console.log("saved ex");
      this.dialogMode = "";
      this.dialog = true;
    },
    onLoadedRef(arr) {
      this.$set(this.results, "attributes", arr[0].doc.attributes);
    },
    onLoadedEx(arr) {
      if (arr) {
        this.$set(this.doc, "benefits", arr[0].doc.benefits);
      }
    },
    onSavedNext() {
      // this.nextStep();
      console.log("saved exercise");
    },
    closeDialog() {
      this.dialog = false;
    },
    handleEnd() {
      console.log("handleEnd");
      this.doAutoSave();
    },
    doAutoSave() {
      if (this.autoSave) {
        this.saveState = true;
      }
    },
  },
};
</script>

<style lang="scss">
.results-container {
  display: flex;
  min-height: 100vh;
}
</style>
